module.exports = __webpack_public_path__ + "videos/mts-products-chats-promo-mobile.7020315.webm";